var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "seat-container",
    },
    [
      _c(
        "div",
        {
          staticClass: "outsideDiv",
          staticStyle: { display: "flex", "justify-content": "center" },
        },
        [
          _c(
            "div",
            {
              ref: "capture",
              staticClass: "leftContainer",
              attrs: { id: "leftContainer" },
            },
            [
              !_vm.uploadedFileInfo
                ? _c("div", { staticClass: "rowDiv" }, [_vm._m(0)])
                : _vm._e(),
              !_vm.uploadedFileInfo
                ? _c(
                    "div",
                    { staticClass: "seatDiv", attrs: { id: "seatDiv" } },
                    [
                      _c(
                        "table",
                        { staticStyle: { width: "100%" } },
                        _vm._l(_vm.seatAry, function (s, sindex) {
                          return _c(
                            "tr",
                            { key: sindex },
                            [
                              _vm._l(s, function (seat, seatIndex) {
                                return [
                                  seat.display
                                    ? _c(
                                        "td",
                                        {
                                          key: seatIndex,
                                          attrs: {
                                            rowspan:
                                              (!seat.isSeat &&
                                                sindex == 0 &&
                                                seatIndex == 4) ||
                                              (sindex == 7 && seatIndex == 4)
                                                ? 2
                                                : 1,
                                          },
                                        },
                                        [
                                          _c(
                                            "div",
                                            {
                                              class: {
                                                noseat: !seat.isSeat,
                                                rightRowSpan:
                                                  (sindex == 0 &&
                                                    seatIndex == 4) ||
                                                  (sindex == 7 &&
                                                    seatIndex == 4),
                                                leftline:
                                                  sindex == 6 && seatIndex == 0,
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    !seat.isSeat
                                                      ? sindex == 0 &&
                                                        seatIndex == 4
                                                        ? "前門"
                                                        : sindex == 7 &&
                                                          seatIndex == 4
                                                        ? "後門"
                                                        : sindex == 6 &&
                                                          seatIndex == 0
                                                        ? "安全門"
                                                        : ""
                                                      : ""
                                                  ) +
                                                  " "
                                              ),
                                            ]
                                          ),
                                          seat.isSeat &&
                                          seat.user &&
                                          seat.user.name
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass: "seat",
                                                  attrs: {
                                                    position: [
                                                      sindex,
                                                      seatIndex,
                                                    ],
                                                    info: JSON.stringify(
                                                      seat.user
                                                    ),
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "drag-source",
                                                      staticStyle: {
                                                        "white-space":
                                                          "pre-wrap",
                                                      },
                                                      attrs: {
                                                        info: JSON.stringify(
                                                          seat.user
                                                        ),
                                                        draggable: "true",
                                                        id:
                                                          "drag-source-" +
                                                          seat.user.id,
                                                        position: [
                                                          seat.position[0],
                                                          seat.position[1],
                                                        ],
                                                      },
                                                    },
                                                    [
                                                      _vm._v(
                                                        " " +
                                                          _vm._s(
                                                            seat.user.name.replace(
                                                              /-/g,
                                                              "\n"
                                                            )
                                                          ) +
                                                          " "
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          seat.isSeat && !seat.user
                                            ? _c("div", {
                                                staticClass: "seat",
                                                attrs: {
                                                  position: [sindex, seatIndex],
                                                },
                                              })
                                            : _vm._e(),
                                        ]
                                      )
                                    : _vm._e(),
                                ]
                              }),
                            ],
                            2
                          )
                        }),
                        0
                      ),
                    ]
                  )
                : _vm._e(),
              _vm.uploadedFileInfo
                ? _c(
                    "div",
                    {
                      staticClass: "seatDiv",
                      staticStyle: { width: "100%", "text-align": "center" },
                    },
                    [
                      _vm.uploadedFileInfo.type === "img"
                        ? _c("img", {
                            staticStyle: { "max-width": "100%" },
                            attrs: { src: _vm.uploadedFileInfo.url },
                          })
                        : _vm._e(),
                      _vm.uploadedFileInfo.type === "pdf"
                        ? _c("iframe", {
                            staticStyle: { width: "100%", height: "600px" },
                            attrs: {
                              src: _vm.uploadedFileInfo.url,
                              frameborder: "0",
                            },
                          })
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              !_vm.uploadedFileInfo
                ? _c("div", { staticClass: "rowDiv" }, [_vm._m(1)])
                : _vm._e(),
            ]
          ),
          _c("div", { staticClass: "sourceDiv" }, [
            _c(
              "div",
              { staticClass: "source-container" },
              _vm._l(_vm.groupedArray, function (group, index) {
                return _c("div", { key: index }, [
                  _c(
                    "div",
                    {
                      staticClass: "source-title",
                      on: {
                        click: function ($event) {
                          _vm.groupKeyName == group.key
                            ? (_vm.groupKeyName = null)
                            : (_vm.groupKeyName = group.key)
                        },
                      },
                    },
                    [
                      _c("h3", [_vm._v(_vm._s(group.key))]),
                      _c("el-icon", {
                        attrs: {
                          name:
                            _vm.groupKeyName == group.key
                              ? "arrow-up"
                              : "arrow-down",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.groupKeyName == group.key,
                          expression: "groupKeyName == group.key",
                        },
                      ],
                      staticClass: "source-list",
                    },
                    _vm._l(group.items, function (item, itemIndex) {
                      return _c(
                        "span",
                        {
                          key: itemIndex,
                          staticClass: "drag-source",
                          attrs: {
                            position: null,
                            draggable: "true",
                            id: "drag-source-" + item.id,
                            info: JSON.stringify(item),
                          },
                        },
                        [_vm._v(" " + _vm._s(item.name) + " ")]
                      )
                    }),
                    0
                  ),
                ])
              }),
              0
            ),
          ]),
          _c("div", { staticClass: "pricessDiv" }, [
            _c(
              "div",
              { staticClass: "process-container" },
              [
                [
                  _c(
                    "div",
                    { staticStyle: { margin: "5px", "margin-top": "0px" } },
                    [
                      _c(
                        "el-radio-group",
                        {
                          on: { change: _vm.seatTypeHandle },
                          model: {
                            value: _vm.seatType,
                            callback: function ($$v) {
                              _vm.seatType = $$v
                            },
                            expression: "seatType",
                          },
                        },
                        [
                          _c("el-radio-button", { attrs: { label: 1 } }, [
                            _vm._v("左駕型式"),
                          ]),
                          _c("el-radio-button", { attrs: { label: 2 } }, [
                            _vm._v("右駕型式"),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticStyle: { margin: "5px", "margin-top": "10px" } },
                    [
                      _c(
                        "el-button",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.isCanSave,
                              expression: "isCanSave",
                            },
                          ],
                          staticStyle: { color: "#4b4b4b" },
                          attrs: { type: "warning" },
                          on: { click: _vm.saveData },
                        },
                        [_vm._v("儲存")]
                      ),
                      _c(
                        "el-button",
                        {
                          on: {
                            click: function ($event) {
                              return _vm.fatherDialogFormVisible(false)
                            },
                          },
                        },
                        [_vm._v(" 取消 ")]
                      ),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.isCanSave,
                          expression: "isCanSave",
                        },
                      ],
                      staticStyle: { margin: "5px", "margin-top": "10px" },
                    },
                    [
                      _c("Upload", {
                        ref: "uploadRef",
                        attrs: {
                          accept: ".jpg,.jpeg,.png,.pdf",
                          payload: _vm.uploadPayload,
                          "data-obj": _vm.fileObj,
                          limitText: "檔案須為圖片或pdf格式，限制不超過2000MB",
                          "limit-file-count": 1,
                          "use-drag": false,
                          action: "TravelSettings/saveTravelSeat",
                          "auto-upload": false,
                          "show-file-list": true,
                          "before-file-list": _vm.fileList,
                          "btn-txt": "選取座位表檔案",
                        },
                        on: { remove: _vm.handleRemoveFile },
                      }),
                    ],
                    1
                  ),
                ],
              ],
              2
            ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { staticStyle: { "font-size": "14px" } }, [
      _c("tr", [
        _c("td", [_c("div", { staticClass: "leftrow" }, [_vm._v("一排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "leftrow" }, [_vm._v("二排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "leftrow" }, [_vm._v("三排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "leftrow" }, [_vm._v("四排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "leftrow" }, [_vm._v("五排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "leftrow" }, [_vm._v("六排")])]),
      ]),
      _c("tr", [_c("td", [_c("div", { staticClass: "leftrow" })])]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "leftrow" }, [_vm._v("七排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "leftrow" }, [_vm._v("八排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "leftrow" }, [_vm._v("九排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "leftrow" }, [_vm._v("十排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "leftrow" }, [_vm._v("十一排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "leftrow" }, [_vm._v("十二排")])]),
      ]),
    ])
  },
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("table", { staticStyle: { "font-size": "14px" } }, [
      _c("tr", [_c("td", [_c("div", { staticClass: "rightrow" })])]),
      _c("tr", [_c("td", [_c("div", { staticClass: "rightrow" })])]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "rightrow" }, [_vm._v("二排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "rightrow" }, [_vm._v("三排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "rightrow" }, [_vm._v("四排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "rightrow" }, [_vm._v("五排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "rightrow" }, [_vm._v("六排")])]),
      ]),
      _c("tr", [_c("td", [_c("div", { staticClass: "rightrow" })])]),
      _c("tr", [_c("td", [_c("div", { staticClass: "rightrow" })])]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "rightrow" }, [_vm._v("九排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "rightrow" }, [_vm._v("十排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "rightrow" }, [_vm._v("十一排")])]),
      ]),
      _c("tr", [
        _c("td", [_c("div", { staticClass: "rightrow" }, [_vm._v("十二排")])]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }